<template>
  <b-modal :id="id" size="xl" title="Add New Credit Group" @show="resetModal" @hidden="resetModal" @ok="handleOk">
    <b-table
      stacked
      class="align-middle"
      :borderless="true"
      :fields="[
          {
            key: 'name',
            label: 'Name'
          },
          {
            key: 'credits',
            label: 'Assigned Credits'
          },
          {
            key: 'examList',
            label: 'Assigned Exams'
          },
          {
            key: 'order',
            label: 'Order'
          },
        ]"
      :items="[{
        name,
        credits,
        examList
      }]"
    >
      <template v-slot:cell(name)>
        <b-form-input v-model="name"></b-form-input>
      </template>
      <template v-slot:cell(credits)>
        <b-form-input v-model="credits" @keypress="filterNumberOnlyWithMax($event)"></b-form-input>
      </template>
      <template v-slot:cell(examList)>
        <Multiselect v-model="selectedExams" :options="examList" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select Exams..." label="name" track-by="name" :preselect-first="false">
          <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selectedExams selected</span></template>
        </Multiselect>
      </template>
      <template v-slot:cell(order)>
        <ol>
          <li v-for="exam in selectedExams" :key="exam.id">
            {{ exam.name }}
          </li>
        </ol>
      </template>
    </b-table>

    <template v-slot:modal-footer="{ ok, cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="sm" variant="secondary" @click="cancel()">Cancel</b-button>
      <b-button
        size="sm"
        :disabled="!isFormValid ? `disabled` : null "
        variant="primary"
        class="bg-site-primary"
        @click="ok()"
      >Add Credit Group</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: `CreditGroupAddModal`,
  components: {
  },
  data() {
    return {
      examList : [],

      name: null,
      credits: 0,
      selectedExams : [],
    };
  },
  mounted () {
    this.getAllExams()
  },
  props: {
    id: String,
    clientId : String,
  },
  computed: {
    availableCredits(){
      return this.credits - this.nonActiveExamineeCount
    },
    isFormValid() {
      const isNameValid = this.name != null && this.name.length > 0
      const isCreditsValid = !isNaN(this.credits) && this.credits > 0
      const isExamValid = this.selectedExams.length > 0;

      return isNameValid && isCreditsValid && isExamValid
    }
  },
  methods: {
    getAllExams() {
      this.$store
        .dispatch("exam/getAllSimple")
        .then((data) => (this.examList = data.data));
    },
    filterNumberOnlyWithMax(evt) {
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        if (isNaN(this.newExaminees) || this.newExaminees < 0) {
          this.newExaminees = 0;
        }
        return true;
      }
    },
    resetModal() {
      var dateNow = new Date()
      dateNow.setFullYear(dateNow.getFullYear() + 1);
      this.expiryDate = dateNow
    },
    handleOk() {
      // Check if Values are complete
      if (!this.isFormValid) {
        return false;
      } 
      else {
        const name = this.name, 
          clientId = this.clientId,
          credits = this.credits,
          selectedExams = this.selectedExams
        this.$store
          .dispatch(`creditGroup/create`, { clientId, credits, name, selectedExams})
          .then(() => {
            this.$emit("ok");
          });
      }
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
</style>